import { FC } from "react";
import ButtonUI from "../../../../../components/button/buttons";
import { Container, Stack, Typography } from "@mui/material";
import TitleValue from "../../../../../components/title-value";

export const ModalWithdrawl = ({
  data,
  onClickBack,
  onClickAccept,
  loading,
}: any) => {
  return (
    <Container maxWidth="xs">
      <Container
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <TitleValue title="Se solicitara un retiro" />
      </Container>
      <Stack direction="column" justifyContent="space-evenly" spacing="10px">
        <Typography fontWeight="bold" color="#00350392">
          {" "}
          {"Total de retiro: $" + data?.amount + " MXN"}
        </Typography>
        <Typography>
          {"Nombre de la cuenta: " + data?.stp_date?.name}{" "}
        </Typography>
        <Typography>{"Cuenta: " + data?.stp_date?.account_number} </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        padding="5px"
      >
        <ButtonUI id="button-back" title="Regresar" onClick={onClickBack} />
        <ButtonUI
          loading={loading}
          id="button-create-withdrawl"
          title="Solicitar retiro"
          color="primary"
          onClick={onClickAccept}
        />
      </Stack>
    </Container>
  );
};
